import RadioGroup from '../radio/src/radio-group.vue';

RadioGroup.install = function(Vue) {
  Vue.component(RadioGroup.name, RadioGroup);
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/radio-group/index.js